// extracted by mini-css-extract-plugin
module.exports = {"tooltipContainer":"styles_tooltipContainer__dijH1","tooltipArrowContainer":"styles_tooltipArrowContainer__bxt9M","tooltipArrowElement":"styles_tooltipArrowElement__A5KPS"};